import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const FavoritItemInner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${SPACING.SMALL_2};
    width: 100%;
    padding: ${SPACING.SMALL_2};

    .ab-favorite-item-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        text-align: center;
    }
`;
